import { useEffect, useState } from 'react';
import classes from './SettingOutsourcingToMail.module.scss';
import AddButton from '../../uikit/atoms/buttons/AddButton';
import SetToOutMailTable from './table/SetToOutMailTable';
import AddOutsourcingMailModal from './modal/AddOutsourcingMailModal';
import { AddressInfoType } from '../../../types';
import { useGetAddressList } from '../../../hooks/api/address/useGetAddress';
const SettingOutsourcingToMail = () => {
  const [isShowAddDialog, setIsShowAddDialog] = useState(false);
  const [addressList, setAddressList] = useState<AddressInfoType[]>([]);
  const { getToAddressList } = useGetAddressList();
  useEffect(() => {
    const fetchToAddressList = async () => {
      const res = await getToAddressList('', '');
      setAddressList(res);
    };
    fetchToAddressList();
  }, []);

  return (
    <div className={classes.container}>
      <div className={classes.header}>
        <div className={classes.title}>To</div>
        <AddButton
          label={'新規'}
          disabled={false}
          onClick={(event: any) => {
            setIsShowAddDialog(true);
          }}
        />
      </div>
      <div className={classes.table}>
        <SetToOutMailTable
          addressList={addressList}
          getAddressList={getToAddressList}
          setAddressList={setAddressList}
        />
      </div>
      {isShowAddDialog && (
        <AddOutsourcingMailModal
          open={isShowAddDialog}
          setOpen={setIsShowAddDialog}
          getAddressList={getToAddressList}
          setAddressList={setAddressList}
        />
      )}
    </div>
  );
};

export default SettingOutsourcingToMail;
